module.exports = __webpack_public_path__ + "static/img/header.749eb89c.png";